/* eslint-disable import/prefer-default-export */
import { gql } from '@apollo/client';

export const DUPLICATE_VALIDATED_PROPERTY_ITEMS = gql`
  query DuplicateValidatedPropertyItems($propertyId: ID!, $name: String!) {
    duplicateValidatedPropertyItems(propertyId: $propertyId, name: $name) {
      id
      name
      itemCount
    }
  }
`;
